<template>
  <div class="timetable">
    <div
      class="ui-container ui-container--small"
    >
      <div class="table">
        <div class="table__head">
          <div class="table__time"></div>
          <div
            class="table__day table__title"
            :data-state="[(currentDay === 0) ? 'active' : '']"
            @click="currentDay = 0"
          >
            <h3 v-html="data.days[0]"></h3>
          </div>
          <div
            class="table__day table__title"
            :data-state="[(currentDay === 1) ? 'active' : '']"
            @click="currentDay = 1"
          >
            <h3 v-html="data.days[1]"></h3>
          </div>
        </div>
        <div class="table__body">
          <aside class="table__time">
            <div
              class="timeline__hour"
              v-for="hour in hours"
              :key="hour"
            >
              <time :datetime="hour">{{ hour }}</time>
            </div>
          </aside>

          <div class="table__day"
            v-for="(event, objkey, index) in data.events"
            :key="event.order"
            v-show="showCol(index)"
          >
            <TimetableItem
              v-for="(schedule, index) in orderedEvents(objkey)"
              :starts="starts"
              :key="`schedule_${index}`"
              :data="schedule"
              class="schedule__item"
            />
            <div class="schedule__hour" v-for="hour in hours" :key="hour"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/scripts/utils';

import TimetableItem from '@/components/TimetableItem.vue';

import starts from '@/assets/data/starts.json';

export default {
  name: 'Timetable',

  components: {
    TimetableItem,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      starts,
      currentDay: 0,

      isMobile: isMobile(),
      col: 0,
    };
  },

  computed: {
    hours() {
      return starts.filter(start => starts.indexOf(start) % 6 === 0 && starts.indexOf(start) < 138);
    },
  },

  created() {
    this.$eventHub.$on('windowResize', this.resize);
  },

  methods: {
    orderedEvents(key) {
      return this.data.events[key].sort((a, b) => a - b); // eslint-disable-line
    },

    showCol(index) {
      if (!this.isMobile) return true;

      return (index === this.currentDay);
    },

    resize() {
      this.isMobile = isMobile();
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('windowResize');
  },
};
</script>

<style lang="scss" scoped>
$halfHourPx: 260px;

.timetable {
  .ui-container--small:not(.ui-container--big-text) {
    padding: 0;

    @include mq(ipadP) {
      padding: 0 40px;
    }

    @include mq(ipadL) {
      padding: 0 80px;
    }
  }

  .table {
    display: flex;
    flex-flow: row wrap;

    &__head, &__body {
      position: relative;
      width: 100%;
      flex: 0 0 100%;

      display: flex;
      flex-flow: row wrap;
    }

    &__head {

      &::after {
        content: '';
        position: absolute;

        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;

        background: $color-title;
      }
    }

    &__title {
      padding: 15px 0 30px;
      text-align: center;
      h3 {
        height: auto;
        margin: 0;
        font-size: 1.5em;

        @include mq(mobile) {
          font-size: 1.875em;
        }

        @include mq(ipadP) {
          font-size: 2.5em;
        }
      }

      &[data-state=""] {
        opacity: 0.3;

        @include mq(ipadP) {
          opacity: 1;
        }
      }
    }

    &__time {
      position: relative;
      max-width: 120px;
      flex-basis: 16%;

      &::after {
        content: '';
        position: absolute;

        top: 0;
        right: 0;
        width: 1px;
        height: 100%;

        background: $color-title;
      }

      time {
        display: inline-block;
        transform: rotate(-90deg);


        @include mq(ipadP) {
          transform: rotate(0deg);
        }
      }

      & > * {
        display: block;
        position: relative;
        height: $halfHourPx;

        text-align: center;
        line-height: $halfHourPx;
        font-weight: 700;


        &::after {
          content: '';
          position: absolute;

          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;

          background: #D5D5D5;
        }

        &:last-child {
          &::after {
            content: none;
          }
        }
      }
    }

    &__day {
      position: relative;
      flex-grow: 1;
      flex-basis: 42%;

      @include mq(ipadP) {
        &:last-child {
          &::after {
            content: '';
            position: absolute;

            top: 0;
            left: 0;
            width: 1px;
            height: 100%;

            background: $color-title;
          }
        }
      }


      & > * {
        height: $halfHourPx;
      }

      .schedule {
        &__hour {
          position: relative;

          &::after {
            content: '';
            position: absolute;

            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;

            background: #D5D5D5;
          }

          &:last-child {
            &::after {
              content: none;
            }
          }
        }

        &__item {
          position: absolute;
          top: 0;
          left: 20px;

          z-index: 2;
        }
      }
    }
  }
}

</style>


<style lang="scss">
sup {
  position: relative;
  top: -0.1em;

  font-size: 50%;
}
</style>
